import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PropTypes from "prop-types";
import { loadPartnerHierarchy, saveAddedPartnersFromHierarchy } from "../actionCreators";
import OfferAddPartnersFromHierarchyComponent from "./OfferAddPartnersFromHierarchyComponent";

export const OfferAddPartnersFromHierarchyContainer = ({
  showModal,
  onCloseHierarchyPartnersModal,
  partnerGroupId,
  documentId,
  siteId
}) => {
  const [localHierarchyPartnersList, setLocalHierarchyPartnersList] = useState([]);
  const dispatch = useDispatch();

  const addPartners = () => {
    let addedPartners = localHierarchyPartnersList.filter(x => x.selected === true).map(x => x.partnerId);
    dispatch(saveAddedPartnersFromHierarchy(documentId, siteId, partnerGroupId, addedPartners, onSaveCallback));
    onCloseModal();
  };

  const onSaveCallback = () => {
    setLocalHierarchyPartnersList(localHierarchyPartnersList.filter(x => x.selected !== true));
  };

  const hierarchyPartnersList = useSelector(
    state => state?.clientData?.partnerHierarchies[partnerGroupId] ?? [],
    shallowEqual
  );

  const associatedPartners = useSelector(state => state.entities.associatedPartners ?? [], shallowEqual);

  const offerClientId = useSelector(state => state.currentOffer.header?.client?.clientId, shallowEqual);

  const offerClientPartnerId = useSelector(
    state => (offerClientId ? state.entities.offerPartners[offerClientId]?.masterPartnerId : undefined),
    shallowEqual
  );

  const onCloseModal = () => {
    onCloseHierarchyPartnersModal();
  };

  const hierarchyPartnersListLoaded = useSelector(
    state => state?.clientData?.partnerHierarchies[partnerGroupId]?.isLoaded ?? false,
    shallowEqual
  );

  const onHierarchyPartnersSelected = idx => e => {
    setLocalHierarchyPartnersList(
      Object.assign([], {
        ...localHierarchyPartnersList,
        [idx]: {
          ...localHierarchyPartnersList[idx],
          selected: e
        }
      })
    );
  };

  useEffect(() => {
    if (hierarchyPartnersListLoaded) {
      let localList = Object.assign([], hierarchyPartnersList);

      var clientIndex = localList.findIndex(a => a.partnerId === offerClientPartnerId);
      if (clientIndex >= 0) localList.splice(clientIndex, 1);

      for (let partner of Object.values(associatedPartners)) {
        let index = localList.findIndex(a => a.partnerId === partner.masterPartnerId);
        if (index >= 0) localList.splice(index, 1);
      }
      setLocalHierarchyPartnersList(localList);
    } else {
      if (partnerGroupId) dispatch(loadPartnerHierarchy(partnerGroupId));
    }
  }, [hierarchyPartnersListLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (partnerGroupId) dispatch(loadPartnerHierarchy(partnerGroupId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <OfferAddPartnersFromHierarchyComponent
      showModal={showModal}
      partnersList={localHierarchyPartnersList}
      addPartners={addPartners}
      onPartnerSelected={onHierarchyPartnersSelected}
      HierarchyPartnersList={localHierarchyPartnersList}
      onCloseModal={onCloseModal}
    />
  );
};

OfferAddPartnersFromHierarchyContainer.propTypes = {
  showModal: PropTypes.bool.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  partnerId: PropTypes.number.isRequired,
  partnerGroupId: PropTypes.number.isRequired,
  onCloseHierarchyPartnersModal: PropTypes.func.isRequired
};

export default OfferAddPartnersFromHierarchyContainer;
